import React from 'react';
import { useCustomComponent } from '@/hooks';
import { Button } from '../../ui';

export interface QuestionnaireSubmitButtonProps
  extends React.ComponentProps<typeof Button> {}

const SubmitButtonComponent: React.FC<QuestionnaireSubmitButtonProps> = ({
  children,
  ...buttonProps
}) => {
  return <Button {...buttonProps}>{children}</Button>;
};

export const SubmitButton: React.FC<QuestionnaireSubmitButtonProps> = (
  props: QuestionnaireSubmitButtonProps
) => {
  const Component = useCustomComponent({
    componentName: 'QuestionnaireSubmitButton',
    Component: SubmitButtonComponent,
  });
  return <Component {...props} />;
};
